import ToolTip from "../../ToolTip/ToolTip";

const handleAssign = (params) => {
  return (
    <ToolTip
      content={params.row.category_description || "N/A"}
      expand={params.row.category_description}
    />
  );
};

export const Category_Table_Head = [
  {
    field: "sl_no",
    headerName: "Sl No",
  },
  {
    field: "category_name",
    headerName: "Name",
    width: 350,
  },
  {
    field: "category_description",
    headerName: "Description",
    width: 300,
    renderCell: handleAssign,
  },
  {
    field: "category_created_at",
    headerName: "Created At",
    width: 200,
  },
];
